"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var InventoryEntity_1 = __importDefault(require("./Entity/InventoryEntity"));
var Inventory = /** @class */ (function () {
    function Inventory(session) {
        this.inventory = new InventoryEntity_1.default(session);
    }
    Inventory.prototype.get = function (id) {
        return this.inventory.service.get(id);
    };
    Inventory.prototype.create = function (inventory) {
        return this.inventory.service.create(inventory);
    };
    Inventory.prototype.update = function (id, inventory) {
        return this.inventory.service.update(id, inventory);
    };
    Inventory.prototype.delete = function (id) {
        return this.inventory.service.delete(id);
    };
    return Inventory;
}());
exports.default = Inventory;
//# sourceMappingURL=Inventory.js.map